import React from 'react';
import { Navigate, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Projects from '../pages/Projects';
import Reads from '../pages/Reads';
import Listens from '../pages/Listens';
import AboutMe from '../pages/AboutMe';
import PodcastDetail from '../pages/PodcastDetail';

function Layout() {
  const { pathname } = useLocation();
  const isProjectsPage = pathname.replace(/\/+$/, '') === '/projects';
  const isAboutPage = pathname === '/';

  return (
    <div className={`container${isProjectsPage ? ' projects-layout' : ''}${isAboutPage ? ' about-layout' : ''}`}>
      <div className="left-side">
        <div className="left-content">
          <header className="header">
            <h1 className="name">Alex Bock</h1>
          </header>
          <Navbar />
        </div>
      </div>
      <main
        id="main-content"
        className={`right-side${isProjectsPage ? ' projects-page' : ''}${isAboutPage ? ' about-page' : ''}`}
        tabIndex="-1"
      >
        <Routes>
          <Route path="/" element={<AboutMe />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/reads" element={<Reads />} />
          <Route path="/listens/*" element={<Listens />} />
          <Route path="/podcasts/:id" element={<PodcastDetail headingLevel={2} />} />
          <Route path="/nodes" element={<Navigate to="/" replace />} />
          <Route path="/writing" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
